var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 87.6500 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375-24.7559C10.2051-24.0723 9.76562-23.0469 9.76562-21.9238C9.76562-19.6289 11.5234-17.8711 13.8184-17.8711C14.9414-17.8711 15.9668-18.3105 16.6504-19.043L46.0938-48.6328L41.5527-48.6328L70.9961-19.043C71.6797-18.3105 72.8027-17.8711 73.877-17.8711C76.1719-17.8711 77.8809-19.6289 77.8809-21.9238C77.8809-23.0469 77.4414-24.0723 76.709-24.7559L46.7285-54.9316C45.9961-55.7617 44.9219-56.1523 43.8477-56.1523C42.7246-56.1523 41.6992-55.7617 40.9668-54.9316Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronup);
export default __webpack_public_path__ + "static/media/chevron.up.7db2c93a82dc2ef5593bdd33d7208b7d.svg";
export { ForwardRef as ReactComponent };